/**
 * package: com.inq.flash.client.data
 * class: ChatCommunicationMessage
 * @extends com.inq.flash.messagingframework.Message
 * @constructor
 *
 * @param {com.inq.flash.client.data.Chat} chat - instance of the chat
 * @param {string} text - the text of the message
 * @param {boolean} updateUsername - if true then need to add username field to the message
 */
com.inq.flash.client.data.ChatCommunicationMessage = function(chat, text, updateUsername) {
	var textMessage = "";
	com.inq.flash.messagingframework.Message.call(this);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID,chat.getChatID());
	// Do encoding for chat.data on CR side to affect general CI and CEAPI
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA, text);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT,"1");
	if (updateUsername) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME, chat.getUsername());
	}
	// Send "/ChatInfo" back to CI using Chat System type
	if (text != null) {
		if (text.toLowerCase() === com.inq.flash.client.data.MessageFields.KEY_CHAT_INFO) {
			var buName = com.inq.flash.client.control.FlashPeer.getBusinessUnitDisplayName()
				|| com.inq.flash.client.control.FlashPeer.getBusinessUnitName() || "";
			var agName = com.inq.flash.client.control.FlashPeer.getAgentGroupDisplayName()
				|| com.inq.flash.client.control.FlashPeer.getAgentGroupName() || "";

			textMessage += "Chat Info"
				+ "<br/>Engagement ID: " + chat.getChatID()
				+ "<br/>Agent ID: " + com.inq.flash.client.control.FlashPeer.getAgentID()
				+ "<br/>Business Unit: " + buName
				+ "<br/>Agent Group: " + agName
				+ "<br/>Business Rule: " + com.inq.flash.client.control.FlashPeer.getBrName()
				+ "<br/>Page Marker: " + com.inq.flash.client.control.FlashPeer.getPageMarker();
		} else if (text.toLowerCase().startsWith(com.inq.flash.client.data.MessageFields.KEY_SWITCH_DEBUG)) {
			var param = text.substring(com.inq.flash.client.data.MessageFields.KEY_SWITCH_DEBUG.length + 1)
				.split(":");
			var isDebugEnabled = com.inq.flash.client.control.FlashPeer.debugSwitchForModule(
				param[0],
				com.inq.flash.messagingframework.StringUtils.getBooleanValue(param[1])
			);

			if (isDebugEnabled) {
				textMessage = "Switched debugging logs for module " + param[0]
					+ " to " + param[1];
			} else {
				textMessage = "Debug wasn't enabled, because module:" + param[0]
					+ " is absent or value:" + param[1] + " isn't boolean";
			}
		}

		if (textMessage) {
			com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
				"",
				textMessage,
				com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,
				-1
			);
		}
	}
};
$hxClasses['com.inq.flash.client.data.ChatCommunicationMessage'] = com.inq.flash.client.data.ChatCommunicationMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatCommunicationMessage.__name__ = ["com","inq","flash","client","data","ChatCommunicationMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatCommunicationMessage.__super__ = com.inq.flash.messagingframework.Message;
for(var k in com.inq.flash.messagingframework.Message.prototype ) com.inq.flash.client.data.ChatCommunicationMessage.prototype[k] = com.inq.flash.messagingframework.Message.prototype[k];
/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
com.inq.flash.client.data.ChatCommunicationMessage.prototype.__class__ = com.inq.flash.client.data.ChatCommunicationMessage;
